import { styled } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";

export const PlansDetailsWrapper = styled.div`
    gap: 16px;
    border-radius: 16px;
    padding-top: 24px;
    padding-right: 16px;
    padding-bottom: 12px;
    padding-left: 16px;
    position: relative;
    bottom: 15px;
    background: #FFFFFF;
`;

export const PlansCoverageDetails = styled(Text)`
    font-family: 'Euclid Circular B', 'Inter', sans-serif;
    font-weight: 600;
    font-style: Semibold;
    font-size: 16px;
    leading-trim: NONE;
    line-height: 22px;
    letter-spacing: 0px;
    color: #451999;
`;

export const PlansCoveragePoints = styled.div`
    font-family: 'Euclid Circular B', 'Inter', sans-serif;
    font-weight: 400;
    font-style: Regular;
    font-size: 12px;
    leading-trim: NONE;
    line-height: 18px;
    // line-height: 18px;
    padding: 0;
    color: #36354C;
    @media (min-width: 768px) {
      font-size: 14px;
    }
`;

export const DottedLine = styled.div`
  width: 100%;
  height: 2px;
  background: url('data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="320" height="2" viewBox="0 0 320 2" fill="none"%3E%3Cpath d="M0 1H320" stroke="%23E0E0E8" stroke-dasharray="4 4"/%3E%3C/svg%3E')
    repeat;
  margin: 20px 0px 20px 0px;
`;

export const ImageContainer = styled.div`
    width: 40px;
    height: 40px;
    border-radius: 12px;
    border-width: 1px;
    background: linear-gradient(180deg, #FFFFFF 0%, rgba(245, 245, 245, 0.6) 100%);
    border: 1px solid var(--Border-Disabled-grey50, #F5F5F5);
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const ExtraBenefitsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    max-width: fit-content;
    text-align: center;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 12px; 
    margin-top: 16px;
`;

export const LearnMoreText = styled.button`
    font-family: 'Euclid Circular B', 'Inter', sans-serif;
    font-weight: 500;
    font-style: Medium;
    font-size: 12px;
    leading-trim: NONE;
    line-height: 18px;
    letter-spacing: 0px;
    text-decoration: underline;
    text-decoration-style: solid;
    text-decoration-offset: 0%;
    text-decoration-thickness: 0%;
    @media (min-width: 768px) {
      font-size: 14px;
    }
`;

export const ExtraBenefitsItem = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    text-align: center;
`;